<template>
    <div>
        <div v-show="!selectedReport" class="row mt-5">

            <div class="col-md-2 spark-settings-tabs">
                <aside>
                    <ul class="nav flex-column mb-4 ">
                        <li>
                            <button class="btn btn-primary mb-3" @click="openModal('newReportModal')"><i class="fa fa-file-text-o mr-2" aria-hidden="true"></i>Create New Report</button>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link active float-left" href="#my-custom-reports" @click="getCustomReports('myReports');() =>{this.activeView='myReports'}" aria-controls="reports" role="tab" data-toggle="tab">
                                My Reports
                            </a>
                            <span class="pull-right">{{ reports.myReportsTotal }}</span>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link float-left" href="#my-favorite-custom-reports" @click="getCustomReports('favoriteReports');() =>{this.activeView='favoriteReports'}" aria-controls="reports" role="tab" data-toggle="tab">
                                Favorites
                            </a>
                            <span class="pull-right">{{ reports.favoriteReportsTotal }}</span>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link float-left" href="#company-custom-reports" @click="getCustomReports('companyReports');() =>{this.activeView='companyReports'}" aria-controls="reports" role="tab" data-toggle="tab">
                                Company Reports
                            </a>
                            <span class="pull-right">{{ reports.companyReportsTotal }}</span>
                        </li>
                    </ul>
                </aside>
            </div>
            <div class="col-md-10">

                <div class="tab-content">
                    <div role="tabcard" class="tab-pane active" id="my-custom-reports" >
                        <div class="table-responsive">
                            <div v-if="checked_my_report_ids.length > 0" class="w-full d-flex flex-wrap mt-1 mb-1 bg-grey-light text-grey-darkest border-b border-grey-light">
                                <b-form-checkbox
                                    id="uncheckAll"
                                    class="check_current_checkbox2 custom-margin"
                                    v-model="uncheck_all"
                                    name="uncheckAll"
                                    @change="clearChecked"
                                ></b-form-checkbox>
                                <b-form-checkbox
                                    id="checkAllCompany"
                                    class="check_current_checkbox2 all_checkbox_edited custom-margin"
                                    v-model="check_all"
                                    name="checkAllCompany"
                                    @change="checkAll"
                                >Select All</b-form-checkbox>

                                <span class="ml-3 custom-margin cursor-pointer" @click="deleteReports"><i class="fa fa-trash text-danger"></i><span class="text-teal ml-1">Delete</span></span>
                            </div>

                            <table class="table table-bordered">
                                <thead class="thead-light border-b-0">
                                <tr>
                                    <th class="col-1 py-1 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light text-center" style="width:3%">
                                        <b-form-checkbox
                                            id="checkFirstPageCompany"
                                            class="check_current_checkbox_edited"
                                            v-model="check_first_page"
                                            name="checkFirstPageCompany"
                                            @change="checkFirstPage"
                                        ></b-form-checkbox>
                                    </th>
                                    <th class="col-1 border-b-0">Favorite</th>
                                    <th class="col-4 border-b-0">Name</th>
                                    <th class="col-1 border-b-0">Published</th>
                                    <th class="col-2 border-b-0">Created By</th>
                                    <th class="col-1 border-b-0">Shared</th>
                                    <th class="col-2 border-b-0">Last Updated</th>
                                </tr>
                                </thead>
                                <tbody class="border-1 border-t-0">
                                <tr class="border-t-1 hover:bg-grey-lightest" v-if="reports.myReports.length > 0 && !loadingData" v-for="report in reports.myReports">
                                    <td @click.stop="() => null"
                                        class="border-b border-grey-light text-xs cursor-default text-center align-middle">
                                        <input type="checkbox" class="bg-teal" v-model="checked_my_report_ids"
                                               :id="'reportCheckbox' + report.id" :name="'reportCheckbox' + report.id"
                                               :value="report.id" @click="checkReport">
                                    </td>
                                    <td class="col-2 border-0">
                                        <i class="fa mr-2 text-teal cursor-pointer"
                                           :class="(report.favorited_by_users && report.favorited_by_users.includes(user.id) ? 'fa-star' : 'fa-star-o')"
                                           @click="updateShareAndFavoriteStatus(report.id, report.is_shared, !report.favorited_by_users.includes(user.id), true)"
                                           aria-hidden="true"></i>
                                    </td>
<!--                                    <td class="col-2 border-0"><i class="fa mr-2 text-teal  cursor-pointer" :class="(report.favorite ? 'fa-star' : 'fa-star-o')" @click="updateShareAndFavoriteStatus(report.id, report.is_shared, !report.favorite, true)" aria-hidden="true"></i></td>-->
                                    <td class="col-4 cursor-pointer border-0"  @click="changeReport(report)"> <span class="nav-link">{{ report.name }}</span></td>
                                    <td class="col-1 border-0">{{ report.publish_on_dashboard ? '1' : '0' }}</td>
                                    <td class="col-2 border-0">{{ report.user_name }}</td>
                                    <td class="col-2 border-0"><i class="fa fa-share-alt mr-2 text-teal" aria-hidden="true" v-if="report.is_shared == 1"></i>{{ (report.is_shared == 1)? 'Shared':'Not shared' }}</td>
                                    <td class="col-2 border-0">{{ report.last_updated }}</td>
<!--                                    <td class="col-2 cursor-pointer border-0"><i class="fa fa-trash mr-2 text-teal"></i></td>-->
                                </tr>
                                <tr v-if="reports.myReports.length === 0 && !loadingData">
                                    <td class="col-12 border-0 text-center" colspan="11">No reports created yet</td>
                                </tr>
                                <tr v-if="loadingData">
                                    <td class="col-12 border-0 text-center" colspan="11"><b-spinner variant="primary" label="Spinning" class="mr-2"></b-spinner> Fetching custom reports</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="flex justify-center">
                            <b-pagination
                                @change="goToPage"
                                v-model="reports.myReportsPagination.current_page"
                                :total-rows="reports.myReportsPagination.total"
                                :per-page="reports.myReportsPagination.per_page"
                                first-text="First"
                                prev-text="Prev"
                                next-text="Next"
                                last-text="Last"
                                v-if="reports.myReportsPagination.total > reports.myReportsPagination.per_page"
                            >
                            </b-pagination>
                        </div>
                    </div>


                    <div role="tabcard" class="tab-pane" id="my-favorite-custom-reports" >
                        <div class="table-responsive">
                            <table class="table table-bordered">
                                <thead class="thead-light border-b-0">
                                <tr>
                                    <th class="col-1 border-b-0">Favorite</th>
                                    <th class="col-4 border-b-0">Name</th>
                                    <th class="col-1 border-b-0">Published</th>
                                    <th class="col-2 border-b-0">Created By</th>
                                    <th class="col-1 border-b-0">Shared</th>
                                    <th class="col-2 border-b-0">Last Updated</th>
<!--                                    <th class="col-1 border-b-0">Action</th>-->
                                </tr>
                                </thead>
                                <tbody class="border-1 border-t-0">
                                <tr class="border-t-1 hover:bg-grey-lightest" v-if="reports.favoriteReports.length > 0 && !loadingData" v-for="favoriteReport in reports.favoriteReports">
                                    <td class="col-2 border-0">
                                        <i class="fa mr-2 text-teal cursor-pointer"
                                           :class="(favoriteReport.favorited_by_users && favoriteReport.favorited_by_users.includes(user.id) ? 'fa-star' : 'fa-star-o')"
                                           @click="updateShareAndFavoriteStatus(favoriteReport.id, favoriteReport.is_shared, !favoriteReport.favorited_by_users.includes(user.id), true)"
                                           aria-hidden="true"></i>
                                    </td>
<!--                                    <td class="col-2 border-0"><i class="fa mr-2 text-teal  cursor-pointer" :class="(favoriteReport.favorite ? 'fa-star' : 'fa-star-o')" @click="updateShareAndFavoriteStatus(favoriteReport.id, favoriteReport.is_shared, !favoriteReport.favorite, true)" aria-hidden="true"></i></td>-->
                                    <td class="col-4 cursor-pointer border-0"  @click="changeReport(favoriteReport)"> <span class="nav-link">{{ favoriteReport.name }}</span></td>
                                    <td class="col-1 border-0">{{ favoriteReport.publish_on_dashboard ? '1' : '0' }}</td>
                                    <td class="col-2 border-0">{{ favoriteReport.user_name }}</td>
                                    <td class="col-2 border-0"><i class="fa fa-share-alt mr-2 text-teal" aria-hidden="true" v-if="favoriteReport.is_shared == 1"></i>{{ (favoriteReport.is_shared == 1)? 'Shared':'Not shared' }}</td>
                                    <td class="col-2 border-0">{{ favoriteReport.last_updated }}</td>
<!--                                    <td class="col-2 cursor-pointer border-0"><i class="fa fa-trash mr-2 text-teal"></i></td>-->
                                </tr>
                                <tr v-if="reports.favoriteReports.length === 0 && !loadingData">
                                    <td class="col-12 border-0 text-center" colspan="11">No reports marked as favorite</td>
                                </tr>
                                <tr v-if="loadingData">
                                    <td class="col-12 border-0 text-center" colspan="11"><b-spinner variant="primary" label="Spinning" class="mr-2"></b-spinner> Fetching custom reports</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="flex justify-center">
                            <b-pagination
                                @change="goToPage"
                                v-model="reports.favoriteReportsPagination.current_page"
                                :total-rows="reports.favoriteReportsPagination.total"
                                :per-page="reports.favoriteReportsPagination.per_page"
                                first-text="First"
                                prev-text="Prev"
                                next-text="Next"
                                last-text="Last"
                                v-if="reports.favoriteReportsPagination.total > reports.favoriteReportsPagination.per_page"
                            >
                            </b-pagination>
                        </div>
                    </div>


                    <div role="tabcard" class="tab-pane" id="company-custom-reports" >
                        <div class="table-responsive">
                            <table class="table table-bordered">
                                <thead class="thead-light border-b-0">
                                <tr>
                                    <th class="col-1 border-b-0">Favorite</th>
                                    <th class="col-4 border-b-0">Name</th>
                                    <th class="col-1 border-b-0">Published</th>
                                    <th class="col-2 border-b-0">Created By</th>
                                    <th class="col-1 border-b-0">Shared</th>
                                    <th class="col-2 border-b-0">Last Updated</th>
<!--                                    <th class="col-1 border-b-0">Action</th>-->
                                </tr>
                                </thead>
                                <tbody class="border-1 border-t-0">
                                <tr class="border-t-1 hover:bg-grey-lightest" v-if="reports.companyReports.length > 0 && !loadingData" v-for="companyReport in reports.companyReports">
                                    <td class="col-2 border-0">
                                        <i class="fa mr-2 text-teal cursor-pointer"
                                           :class="(companyReport.favorited_by_users && companyReport.favorited_by_users.includes(user.id) ? 'fa-star' : 'fa-star-o')"
                                           @click="updateShareAndFavoriteStatus(companyReport.id, companyReport.is_shared, !companyReport.favorited_by_users.includes(user.id), true)"
                                           aria-hidden="true"></i>
                                    </td>
<!--                                    <td class="col-2 border-0"><i class="fa mr-2 text-teal  cursor-pointer" :class="(companyReport.favorite ? 'fa-star' : 'fa-star-o')" @click="updateShareAndFavoriteStatus(companyReport.id, companyReport.is_shared, !companyReport.favorite, true)" aria-hidden="true"></i></td>-->
                                    <td class="col-4 cursor-pointer border-0"  @click="changeReport(companyReport)"> <span class="nav-link">{{ companyReport.name }}</span></td>
                                    <td class="col-1 border-0">{{ companyReport.publish_on_dashboard ? '1' : '0' }}</td>
                                    <td class="col-2 border-0">{{ companyReport.user_name }}</td>
                                    <td class="col-2 border-0"><i class="fa fa-share-alt mr-2 text-teal" aria-hidden="true" v-if="companyReport.is_shared == 1"></i>{{ (companyReport.is_shared == 1)? 'Shared':'Not shared' }}</td>
                                    <td class="col-2 border-0">{{ companyReport.last_updated }}</td>
<!--                                    <td class="col-2 cursor-pointer border-0"><i class="fa fa-trash mr-2 text-teal"></i></td>-->
                                </tr>
                                <tr v-if="reports.companyReports.length === 0 && !loadingData">
                                    <td class="col-12 border-0 text-center" colspan="11">No reports created yet</td>
                                </tr>
                                <tr v-if="loadingData">
                                    <td class="col-12 border-0 text-center" colspan="11"><b-spinner variant="primary" label="Spinning" class="mr-2"></b-spinner> Fetching custom reports</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="flex justify-center">
                            <b-pagination
                                @change="goToPage"
                                v-model="reports.companyReportsPagination.current_page"
                                :total-rows="reports.companyReportsPagination.total"
                                :per-page="reports.companyReportsPagination.per_page"
                                first-text="First"
                                prev-text="Prev"
                                next-text="Next"
                                last-text="Last"
                                v-if="reports.companyReportsPagination.total > reports.companyReportsPagination.per_page"
                            >
                            </b-pagination>
                        </div>
                    </div>
                </div>

            </div>

            <!--   New snippet Modal   -->
        </div>
        <div v-show="selectedReport">
            <div>
                <span class="text-primary mb-3 cursor-pointer d-inline-block" @click="clearSelectedReport">
                    <i class="fa fa-chevron-left" aria-hidden="true"></i> Back
                </span>

                <span class="pull-right" v-if="this.selectedReport && this.selectedReport.user_id == this.user.id">
                    <div class="tab-container">
                        <button :class="{'active-tab': activeTab === 'view'}" @click="changeView('view')">
                            View Mode
                        </button>
                        <button :class="{'active-tab': activeTab === 'edit'}" @click="changeView('edit')">
                            Edit Mode
                        </button>
                    </div>
                    <button class="share-report-button" v-if="canShareReport" @click="updateShareAndFavoriteStatus(selectedReport.id, !selectedReport.is_shared, selectedReport.favorited_by_users.includes(user.id), false)">
                        {{(selectedReport && selectedReport.is_shared == 1 ? 'Unshare': 'Share')}}
                    </button>

                     <button class="share-report-button" v-if="selectedReport.user_id == this.user.id" @click="updatePublishToDashboard(selectedReport.id, !selectedReport.publish_on_dashboard)">
                        {{(selectedReport && selectedReport.publish_on_dashboard == 1 ? 'UnPublish': 'Publish')}}
                    </button>
                </span>
            </div>
            <div ref="qrveyContainer">
            </div>
        </div>

        <div class="modal fade" id="newReportModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Create New Report</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal('newReportModal')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="w-100 mb-3">
                            <label>Report Name</label>
                            <input type="text" v-model="reportForm.name" class="form-control border-grey-light shadow-none">
                        </div>
                        <div class="w-100 mb-3">
                            <label>Template</label>
                            <select v-model="reportForm.template" class="form-control border-grey-light shadow-none">
                                <option :value="0">Blank Report</option>
                                <option v-for="report in [...reports.myReports, ...reports.companyReports]" :value="report.id">{{ report.name }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeModal('newReportModal')">Cancel</button>
                        <button type="button" class="btn btn-primary" @click="createNewReport()">Create</button>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
import Mixin from './mixin';
import GlobalMixin from '../../../../spark/resources/assets/js/mixin';
import Form from "../../utils/form";
import Multiselect from "vue-multiselect";
import MergeCompany from "../company/merge-company.vue";
import axios from "axios";
import Swal from "sweetalert2";

export default {
    mixins: [Mixin, GlobalMixin],

    name: 'custom-reports',

    props: ['filter-uri', 'userRole', 'team', 'user'],
    components: {MergeCompany},
    data() {
        return {
            selected: null,
            reports:{
                myReports: [],
                myReportsPagination: [],
                myReportsTotal: 0,
                companyReports: [],
                companyReportsPagination: [],
                companyReportsTotal: 0,
                favoriteReports: [],
                favoriteReportsPagination: [],
                favoriteReportsTotal: 0
            },
            loadingData: false,
            reportForm: new Form({
                name: '',
                template: '',
            }),
            selectedReport: null,
            pageConfig: {
                domain: 'https://gxwvn.qrveyapp.com',
                app_id: this.team.qrvey_app_id,
                user_id: this.team.qrvey_app_owner_id,
                qv_token: "",
                dashboard_id: "",
                single_page_edit: true,
                featurePermission: {},
                personalization: {
                    enabled: true,
                }
            },
            loadingWidget: false,
            widgetContainer: null,
            activeTab: 'view',
            checked_my_report_ids: [],
            allMyReportsIds: [],
            check_all: false,
            uncheck_all: true,
            check_first_page: false,
            page: 1,
            pagination: {
                meta: {}
            },
            activeView: 'myReports',
        }
    },
    created(){
        this.getCustomReports('myReports');
        this.getCustomReports('favoriteReports');
        this.getCustomReports('companyReports');
    },
    mounted() {
        window['smartan'] = true;
    },
    methods: {
        getCustomReports(type){
            this.loadingData = true;
            let params = {
                page: this.page,
                reportType: type
            }
            axios.get(route('api.qrvey.get-reports'), {params}).then((response) => {
                this.reports[type] = response.data.data
                this.reports[type+'Pagination'] = response.data.meta
                this.reports[type+'Total'] = response.data.allMyReportsIds ? response.data.allMyReportsIds.length : 0
                if(type == 'myReports'){
                    this.allMyReportsIds = response.data.allMyReportsIds
                }
                this.loadingData = false;

                if(this.selectedReport){
                    this.selectedReport = this.reports[this.activeView].find(report => report.id == this.selectedReport.id)
                }
            });
        },
        createNewReport() {
            if(!this.reportForm.name){
                this.getToast().fire({
                    type: 'error',
                    title: "Report Name is required."
                });
            }else{
                this.reportForm.post(route('api.qrvey.create-report')).then((response) => {
                    this.reportForm.reset();
                    this.closeModal('newReportModal');
                    if (response.status) {
                        this.getToast().fire({
                            type: 'success',
                            title: response.message
                        });
                        this.getCustomReports(this.activeView);
                    } else {
                        this.getToast().fire({
                            type: 'error',
                            title: response.message
                        });
                    }
                });
            }
        },
        openModal(modalId) {
            $('#'+modalId).modal('show');
        },
        closeModal(modalId) {
            $('#'+modalId).modal('hide');
        },
        clearSelectedReport() {
            this.selectedReport = null;
            this.getCustomReports('myReports');
        },
        changeReport(report) {
            if(report.user_id !== this.user.id && !report.published){
                this.getToast().fire({
                    type: 'error',
                    title: "This report is in edit mode."
                });
                return false;
            }
            this.selectedReport = report;
            this.pageConfig.dashboard_id = this.selectedReport.report_id;

            this.activeTab = this.selectedReport.published ? 'view' : 'edit';
            this.loadingOn();
            this.$nextTick(() => {
                this.loadingOn();
                const clientId = this.selectedReport.user_id === this.user.id ? null : this.user.uuid;
                this.loadQrveyPageWidget(this.team, this.selectedReport.report_id, this.$refs.qrveyContainer, !this.selectedReport.published, true, true, clientId)
            })
        },
        changeView(mode) {
            this.activeTab = mode;
            let updates = {};
            let builder = false;
            if (mode == 'view') {
                updates = { editing: false, published: true, updateTo: "Published", forceUpdate: true, selected: false };
            } else {
                updates = { editing: true, published: true, updateTo: "Published", forceUpdate: true };
                builder= true;
            }
            this.updatePageStatus(updates, () => {
                const clientId = this.selectedReport.user_id === this.user.id ? null : this.user.uuid;
                this.loadQrveyPageWidget(this.team, this.selectedReport.report_id, this.$refs.qrveyContainer, builder, true, true, clientId)
            });
        },
        updatePageStatus(updates, callback){
            this.loadingOn();

            axios.post(route('api.qrvey.get-report'), {reportId: this.selectedReport.report_id})
                .then((response) => {

                    let report = response.data.report;
                    report = { ...report, ...updates };
                    const updatedBody = {
                        userid: this.team.qrvey_app_owner_id,
                        appid: this.team.qrvey_app_id,
                        pageid: this.selectedReport.report_id,
                        qbody: report
                    };


                    axios.post(route('api.qrvey.update-report'), {reportBody: updatedBody})
                        .then((response) => {
                            callback();

                        })
                        .catch(error => {
                            console.log("update report error", error);
                            if (typeof callback === 'function') {
                                callback(null, error);
                            }
                        });

                })
                .catch(error => {
                    console.log("get report error", error);
                    if (typeof callback === 'function') {
                        callback(null, error);
                    }
                });
        },
        loadingOn() {
            this.widgetContainer = this.$refs.qrveyContainer;
            this.widgetContainer.innerHTML = '';
        },
        updateShareAndFavoriteStatus(reportId, share, favorite, isFavorite) {
            axios.post(route('api.qrvey.share-favorite-report'), {
                shared: share,
                favorite: favorite,
                reportId: reportId,
            }).then((response) => {

                if (response.status) {
                    let message = ''
                    if(isFavorite){
                        message = favorite ? 'Added to favorites' : 'Removed from favorites'
                    }else{
                        message = share ? 'Report shared successfully' : 'Report unshared successfully'
                    }
                    this.getToast().fire({
                        type: 'success',
                        title: message
                    });
                    // this.getCustomReports(this.activeView);
                    this.getCustomReports('myReports');
                    this.getCustomReports('favoriteReports');
                    this.getCustomReports('companyReports');

                } else {
                    this.getToast().fire({
                        type: 'error',
                        title: "Try again later."
                    });
                }
            });
        },
        updatePublishToDashboard(reportId, publish_on_dashboard) {
            axios.post(route('api.qrvey.publish-report-to-dashboard'), {
                publish_on_dashboard: publish_on_dashboard,
                reportId: reportId,
            }).then((response) => {

                if (response.status) {
                    this.getToast().fire({
                        type: 'success',
                        title: publish_on_dashboard ? "Successfully published to dashboard" : "Successfully unPublished from dashboard"
                    });
                    this.getCustomReports(this.activeView);
                } else {
                    this.getToast().fire({
                        type: 'error',
                        title: "Try again later."
                    });
                }
            });
        },
        checkReport(id) {
            this.check_first_page = false;
            this.check_all = false;
            if(!event.target.checked){
                if(this.checked_my_report_ids.indexOf(id, 0) !== -1){
                    this.checked_my_report_ids.splice(this.checked_my_report_ids.indexOf(id, 0), 1);
                }
            }

            if(parseInt(this.checked_my_report_ids.length) == parseInt(this.allMyReportsIds.length)) {
                this.check_all = true;
            }
        },
        clearChecked() {
            this.check_all = false;
            this.check_first_page = false;
            this.checked_my_report_ids = [];
        },
        checkAll(val) {
            if(val){
                this.checked_my_report_ids = this.allMyReportsIds;
                this.check_first_page = true;
            }else{
                this.check_all = false;
                this.check_first_page = false;
                this.checked_my_report_ids = [];
            }
        },
        deleteReports(){
            Swal.fire({
                title: 'Delete Reports',
                text: 'Do you want to delete selected reports',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#01B1AF',
                confirmButtonText: 'Confirm',
                closeOnConfirm: false,
            }).then((resultOther) => {
                if (resultOther.value) {
                    axios.post(route('api.qrvey.delete-reports'), {
                        reportIds: this.checked_my_report_ids,
                    }).then((response) => {

                        if (response.status) {
                            this.getToast().fire({
                                type: 'success',
                                title: response.data.message
                            });
                            this.page = 1
                            this.clearChecked();
                            this.getCustomReports(this.activeView);

                        } else {
                            this.getToast().fire({
                                type: 'error',
                                title: response.data.message
                            });
                        }
                    });

                }
            });
        },
        checkFirstPage(){
            this.$nextTick(() => {
                if(this.check_first_page){
                    let firstPageReportIds = [];
                    this.reports[this.activeView].forEach(report => {
                        firstPageReportIds.push(report.id);
                    });
                    this.checked_my_report_ids = firstPageReportIds;
                }
            });
        },
        goToPage(page) {
            this.page = page;
            this.getCustomReports(this.activeView);
        },
    },
    computed: {
        canShareReport(){
            if(['owner', 'sr_manager', 'admin', 'administrative', 'executive'].includes(this.userRole)){
                return true;
            }else{
                return false;
            }
        }
    }
};
</script>

<style scoped>
.tab-container {
    display: inline-flex;
    border: 1px solid #01b1af;
    border-radius: 5px;
    overflow: hidden;
    margin-top:1px;
}

.tab-container button {
    background-color: #ffffff;
    border: none;
    padding: 5px 10px;
    cursor: pointer;
    outline: none;
    color: #01b1af;
}

.tab-container button.active-tab {
    background-color: #01b1af ;
    color: #ffffff;
}

.tab-container button:not(.active-tab):hover {
    background-color: #f0f0f0;
}

.share-report-button{
    background-color: #01b1af ;
    color: #ffffff;
    border-radius: 5px;
    padding: 5px 10px;
    cursor: pointer;
    outline: none;
    border: 1px solid #01b1af;
}
.share-report-button:hover{
    background-color:#ffffff ;
    color: #01b1af;
}
#my-custom-reports .custom-margin{
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem;
    margin-left: 1.5rem !important;
}

</style>

